import { Component, OnInit, Input, Output } from "@angular/core";
import { Router } from "@angular/router";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { AuthService } from "../../service/auth.service";
import { GeneralService } from "../../service/general.service";

@Component({
    selector: "account-example-dialog",
    templateUrl: "../../../html/incs/account-example-dialog.html"
})
export class AccountExampleDialog implements OnInit {

    constructor(
       public dialogRef: MatDialogRef<AccountExampleDialog>,
    ) {}

    ngOnInit(): void {
    }

    closeDialog() {
      this.dialogRef.close(null!);
    }
}